import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { createBrowserRouter } from 'react-router-dom';

import App from 'shared/src/App';
import GlobalStore from './Store';
import 'react-day-picker/dist/style.css';
import 'shared/src/scss/style.scss';
import reportWebVitals from 'shared/src/reportWebVitals';
import { APIProvider } from '@vis.gl/react-google-maps';

// routing
import LoginRoutes from 'shared/src/components/login/LoginRoutes';
import { PortalRoutes } from './portal/PortalRoutes';
import { g_HttpReq } from 'shared/src/utils/httpUtils';
import { updateUserTokenAsync } from 'shared/src/stores/UserStore';

const container = document.getElementById('root');
const root = createRoot(container);
const router = createBrowserRouter([LoginRoutes, ...PortalRoutes]);

// /////////////////////////////////////////////////////////////////////////////////////////////////
g_HttpReq.setGetStore(() => GlobalStore);

// /////////////////////////////////////////////////////////////////////////////////////////////////
g_HttpReq.setExtraHeaderProvider(() => {
  const state = GlobalStore.getState();
  return { 'X-Org-Id': state?.userOrganization?.entityId };
});

// /////////////////////////////////////////////////////////////////////////////////////////////////
g_HttpReq.setUnauthorizedHandler(() => {
  GlobalStore.dispatch({ type: 'dialog/set', openSessionExpiredDialog: { open: true, props: {} } });
  return true;
});

// /////////////////////////////////////////////////////////////////////////////////////////////////
g_HttpReq.setUpdateUserTokenAsync(updateUserTokenAsync);

// /////////////////////////////////////////////////////////////////////////////////////////////////
root.render(
  <Provider store={GlobalStore}>
    <APIProvider apiKey={process.env.REACT_APP_GOOGLE_MAPS_API_KEY} libraries={['marker', 'places']}>
      <App router={router} />
    </APIProvider>
  </Provider>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
